const slugify = require('slugify');

export function formatDateTime(dt) {
    if (!dt) {
        return ('');
    }

    const d = new Date(dt);

    return `${(`0${d.getDate()}`).slice(-2)}-${(`0${d.getMonth() + 1}`).slice(-2)}-${
        d.getFullYear()} ${(`0${d.getHours()}`).slice(-2)}:${(`0${d.getMinutes()}`).slice(-2)}`;
}

export function getDaysInMonth(m, y) {
    const month = parseInt(m);
    const year = parseInt(y);

    return month === 2 ? (year & 3) || (!(year % 25) && year & 15) ? 28 : 29 : 30 + (month + (month >> 3) & 1);
}

export function formatDateForDRF(dt) {
    if (!dt) {
        return ('');
    }

    const d = new Date(dt);

    return `${d.getFullYear()}-${(`0${d.getMonth() + 1}`).slice(-2)}-${(`0${d.getDate()}`).slice(-2)}`;
}

export function formatDateTimeForDRF(dt) {
    if (!dt) {
        return ('');
    }

    const d = new Date(dt);

    return `${d.getFullYear()}-${(`0${d.getMonth() + 1}`).slice(-2)}-${(`0${d.getDate()}`).slice(-2)}T${
        (`0${d.getHours()}`).slice(-2)}:${(`0${d.getMinutes()}`).slice(-2)}`;
}

export function getMoscowTime() {
    return new Date().toLocaleDateString('en-US', { timeZone: 'Europe/Moscow', hour: 'numeric', minute: 'numeric' });
}

export function getCurrentMoscowDate() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Moscow' }));
}

export function Range(start, stop, step) {
    if (typeof stop === 'undefined') {
        // one param defined
        stop = start;
        start = 0;
    }

    if (typeof step === 'undefined') {
        step = 1;
    }

    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return [];
    }

    const result = [];

    for (let i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i);
    }

    return result;
}

export function Text2Slug(text) {
    return slugify(text.toLowerCase().replace(/[.,/#!$%^&*;:{}=-_`’~()'"“”+]/g, ''), '-');
}
